import React from "react";

export const MotifDivider = ({ label = "Purpose • Execution • Longevity", className = "" }) => {
  return (
    <div className={`flex items-center gap-4 ${className}`} data-testid="motif-divider" aria-hidden="false">
      <span className="h-px flex-1" style={{ background: "var(--card-border)" }} />
      <span className="motif-caps whitespace-nowrap">{label}</span>
      <span className="h-px flex-1" style={{ background: "var(--card-border)" }} />
    </div>
  );
};
